import * as React from 'react';
import {PureComponent} from 'react';
import {mapControlStyle} from "./mapControlStyle";

export default class ZoomOutIcon extends PureComponent <any, any> {

    render() {
        return (
            <svg viewBox="0 0 200 200" style={{...mapControlStyle}}>
                <path d="M100,43.2c31.4,0,56.8,25.4,56.8,56.8c0,31.3-25.4,56.8-56.8,56.8c-31.3,0-56.8-25.4-56.8-56.8
	                C43.2,68.7,68.6,43.2,100,43.2z"/>
                <line x1="78.4" y1="99.9" x2="123.5" y2="100.1"/>
            </svg>
        );
    }
}